import axios from 'axios'
import config from '../config/app'

const PATH = '/search'
const searchAPI = {
  get (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/get', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default searchAPI



// WEBPACK FOOTER //
// ./src/api/search.js